import { render, staticRenderFns } from "./FontAlignement.vue?vue&type=template&id=6784a940&scoped=true"
import script from "./FontAlignement.vue?vue&type=script&lang=js"
export * from "./FontAlignement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6784a940",
  null
  
)

export default component.exports